import React, { useState, useEffect, useRef } from "react";
import Input from "../Input";
import TextInput from "../TextInput";
import Dropdown from "../Dropdown";
import DateInput from "../DateInput";
import MobileInput from "../MobileInput";
import closeIcon from "../../Assets/Icons/close.png";
import search from "../../Assets/Icons/search.png";
import uploadIcon from "../../Assets/Icons/upload.png";
import Loader from "../Loader";
import { ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, ORG_DSC_ADD, ORG_DSC_CERTIFICATE_UPDATE, ORG_GET_ALL_CODES_LIST, ORG_GET_GROUP_LIST, ORG_GET_CLIENT_TYPE_LIST, ORG_GET_EMPLOYEE_LIST, ORG_BULK_UPDATE_OF_CLIENTS_SEARCH } from '../../ApiServices/BaseURL';
import { postData, getData } from '../../ApiServices/ApiService';
import errorIcon from '../../Assets/Icons/error_message.png';
import { validateEmail } from "../../Utils/Validation";
import DeleteConfirmationModal from "./DeleteConformationModal";

const BulkUpdateClientInformationModal = ({ isOpen, onClose, selectedClients, handleCancleClick,onValueChange, documentData }) => {
    // console.log("selectedClients", selectedClients);
    useEffect(() => {
        if (isOpen && documentData) {
            console.log("documentData in DSC", documentData);
            setNameOfClient(documentData?.client_name)
            setOrganisationName(documentData?.org_name);
            setPanNo(documentData?.pan_no);
            setEmailId(documentData?.email_id)
            setValidFrom(documentData?.valid_from);
            setValidTo(documentData?.valid_to);
            setPhysicalTokenNo(documentData?.physical_token_no);
            setPhoneNo(documentData?.mobile_no);
            setCountryCode(documentData?.client_mobile_code_);
            setTokenPassword(documentData?.token_password);
            setAddRemark(documentData?.dsc_remarks);
            setSearchUser(documentData?.client_name);
            setFileUpload(documentData?.e_device_type)
            setStatus(documentData?.dsc_status)
        }
    }, [isOpen, documentData]);

    const [clientFileNo, setClientFileNo] = useState("");
    const [physicalTokenNo, setPhysicalTokenNo] = useState("");
    const [nameOfClient, setNameOfClient] = useState("");
    const [organisationName, setOrganisationName] = useState("");
    const [panNo, setPanNo] = useState("");
    const [emailId, setEmailId] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [countryCode, setCountryCode] = useState('+91');
    const [tokenPassword, setTokenPassword] = useState("");
    const [status, setStatus] = useState("");
    const [fileUpload, setFileUpload] = useState("");
    const [validFrom, setValidFrom] = useState("");
    const [validTo, setValidTo] = useState("");
    const fileInputRef = useRef(null);
    const [uploadedFileName, setUploadedFileName] = useState('');
    const [base64File, setBase64File] = useState('');
    const [fileExtension, setFileExtension] = useState('');
    const [documentUploadError, setDocumentUploadError] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [employeeList, setEmployeeList] = useState([]);
    const [clientSearchError, setClientSearchError] = useState('');
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [addRemark, setAddRemark] = useState('');
    const [digitalSignatureLoading, setDigitalSignatureLoading] = useState(false);
    const [digitalSignatureError, setDigitalSignatureError] = useState('')
    const [digitalSignatureSuccess, setDigitalSignatureSuccess] = useState('')
    const [addPhysicalTokenError, setAddPhysicalTokenError] = useState('');

    const [groupName, setGroupName] = useState('');
    const [cleintAssignedUser, setClientAssignedUser] = useState('');
    const [primaryContact, setPrimaryContact] = useState('');
    const [clientType, setClientType] = useState('');
    const [nri, setNri] = useState('');
    const [address, setAddress] = useState('');
    const [location, setLocation] = useState("");
    const [state, setState] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [selectedLocation, setSelectedLocation] = useState(null)

    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const handleOpenDeleteModal = () => {
        setIsDeleteModalOpen(true);
      };
      
      const handleCloseDeleteModal = () => {
        setIsDeleteModalOpen(false);
      };

    const nriOptions = [
        { label: "YES", value: 1 },
        { label: "NO", value: 2 },
        // { label: "Rejected", value: "rejected" },
    ];

    const fileUploadFrom = [
        { label: "USB", value: 1 },
        { label: "Mail", value: 2 },
        { label: "WhatsApp", value: 3 },
        { label: "Drive", value: 4 },
    ];

    // useEffect(() => {
    //     if (!isOpen) {
    //         resetForm();
    //     }
    // }, [isOpen]);

    useEffect(() => {
        fetchGroupList();
        fetchStateList();
        fetchClientTypesList();
        fetchUserList();
    }, []);

    // const resetForm = () => {
    //     setGroupName('');
    //     setClientAssignedUser("");
    //     setClientType("");
    //     setNri("");
    //     setAddress("");
    //     setLocation("");
    //     setState("");
    //     setPinCode("");
    //     setDocumentUploadError('');
    //     setUploadedFileName('');
    //     setBase64File('')
    //     setDigitalSignatureError('');
    //     setFileUpload('');
    //     setClientTypeError('');
    //     setGroupError('');
    //     setStateError('');
    //     setLoacationError('');
    //     setUserError('')
    // };

    const handleClose = () => {
        onClose();
        setGroupName('');
        setClientAssignedUser("");
        setClientType("");
        setNri("");
        setAddress("");
        setLocation("");
        setState("");
        setPinCode("");
        setDocumentUploadError('');
        setUploadedFileName('');
        setBase64File('')
        setDigitalSignatureError('');
        setFileUpload('');
        setClientTypeError('');
        setGroupError('');
        setStateError('');
        setLoacationError('');
        setUserError('');
        setBulkUpdateOfClientInformationError('')
        setBulkUpdateOfClientInformationSuccess('')
        // setSelectedEmployee(null)
    };

    const handleFileUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        setDocumentUploadError('');
        const files = event.target.files;

        if (files && files.length > 0) {
            const file = files[0];
            const fileName = file.name;
            const fileSize = file.size; // File size in bytes
            const maxFileSize = 2 * 1024 * 1024;
            const fileExtension = fileName.split('.').pop(); // Extract the file extension
            console.log("fileName", fileName);

            //console.log("Uploaded File Name:", fileName);
            //console.log("File Extension:", fileExtension);
            setUploadedFileName(fileName);

            if (fileSize > maxFileSize) {
                setDocumentUploadError("File size exceeds the maximum limit of 2MB.");
                return;
            }

            const reader = new FileReader();

            try {
                reader.onload = () => {
                    try {
                        const base64String = reader.result.split(',')[1]; // Extract Base64 string from result
                        //console.log("Base64 Encoded File:", base64String);

                        setBase64File(base64String); // Add the Base64 string to the payload
                        // Optionally, save the file extension in state or payload
                        setFileExtension(fileExtension);
                    } catch (parseError) {
                        console.error("Error parsing file to Base64:", parseError);
                        setDocumentUploadError("Failed to process the file. Please try again.");
                    }
                };

                reader.onerror = (error) => {
                    console.error("Error reading file:", error);
                    setDocumentUploadError("Failed to read the file. Please try again.");
                };

                reader.readAsDataURL(file); // Convert file to Base64 string
            } catch (readError) {
                console.error("File upload error:", readError);
                setDocumentUploadError("An unexpected error occurred during the file upload. Please try again.");
            }
        } else {
            //   setDocumentUploadError("No file selected. Please choose a file to upload.");
        }
    };
    const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
    const toggleDropdown = (dropdownName) => {
        setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    };

    const handleSearchInputChange = (value) => {
        setSearchUser(value);
        if (!value) {
            setSelectedEmployee(null)
        }
    }

    const handleSelectedEmployee = (employee) => {
        setSelectedEmployee(employee);
        setSearchUser(employee?.client_name);
        setNameOfClient(employee?.client_name);
        // setPanNo(employee?.pan_id);
        setPanNo(employee?.client_pan_no);
        setEmailId(employee?.client_email);
        setPhoneNo(employee?.client_mobile_no);

        setEmployeeList([]); // Clear the dropdown
    };

    const [searchUser, setSearchUser] = useState('');
    const handleSearchEmployee = async () => {

        try {
            setError('');
            setClientSearchError('')
            if (!searchUser) {
                setClientSearchError('Please enter valid text'); return;
            }
            setLoading(true);
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, search_type: "NAME-FILEID", search_word: searchUser }

            //console.log('handleSearchEmployee payload', payLoad);
            // Make the API call
            const response = await postData(ORG_CLIENT_SEARCH_TO_ADD_GROUPMEMBER, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        // setAddEmployeeError('')
                        setEmployeeList(responseData?.dataJ || []);
                        //   setError(responseData?.info);
                        setTimeout(() => {
                            // handleClose();
                            // onValueChange();
                        }, 2000);
                    } else {
                        setError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const clearFeilds = () => {
        setGroupName('');
        setClientAssignedUser('');
        setClientType('');
        setNri('');
        setAddress('');
        setLocation('');
        setState('');
        setPinCode('');
        setDocumentUploadError('');
        setUploadedFileName('');
        setBase64File('')
        setDigitalSignatureError('');
        setFileUpload('');
        setClientTypeError('');
        setGroupError('');
        setStateError('');
        setLoacationError('');
        setUserError('')
    }

    const [bulkUpdateOfClientInformationError, setBulkUpdateOfClientInformationError] = useState('');
    const [bulkUpdateOfClientInformationLoading, setBulkUpdateOfClientInformationLoading] = useState(false);
    const [bulkUpdateOfClientInformationSuccess, setBulkUpdateOfClientInformationSuccess] = useState('');
    const handleBulkUpdateOfClientInformation = async () => {
        // console.log("apply values", groupName?.value, clientType?.value, cleintAssignedUser?.value, nri?.value, address, location, state?.value, pinCode,);
        // return
        console.log("location:", typeof location, location);
        try {

            setError('');
            setBulkUpdateOfClientInformationError('')
            setClientTypeError('');
            setGroupError('');
            setStateError('');
            setLoacationError('');
            setUserError('');
            setBulkUpdateOfClientInformationSuccess('');

            if(!groupName && !clientType && !cleintAssignedUser && !nri && !address && !selectedLocation && !location.trim()  && !state && !pinCode && !base64File){
                setBulkUpdateOfClientInformationError('Please select at least one feild');
                return
            }
            setBulkUpdateOfClientInformationLoading(true);

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = {
                "action": "bulk_update",
                emp_id_auth: storedUserInfo?.emp_id,
                doc_name:uploadedFileName?.split('.')[0],
                doc_base_64: base64File,
                doc_name_with_ext: uploadedFileName,
                // client_name: nameOfClient,
                group_id: groupName?.value || 0,
                emp_id_incharge:cleintAssignedUser?.value ||0,
                client_type_id: clientType?.value ||0,
                is_india_client: nri?.value ||0,
                client_address:address ||'',
                client_city:location ||'',
                client_state: state?.label ||'',
                client_pin: pinCode ||'',
                doc_is_internal: 1,
                client_id: selectedClients
            }

            console.log('handle Bulk Update Of CLient Information payload', payLoad);
            // return
            // Make the API call
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();
            //console.log('response Data', responseData);

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        setSelectedLocation(null);
                        setBulkUpdateOfClientInformationError('')
                        setBulkUpdateOfClientInformationSuccess(responseData?.info);
                        clearFeilds();
                        setTimeout(() => {
                            handleClose();
                            handleCancleClick();
                            // onValueChange();
                        }, 3000);
                    } else {
                        setBulkUpdateOfClientInformationError(responseData?.info || 'Failed to add notice board message. Please try again.');
                    }
                } else {
                    setBulkUpdateOfClientInformationError(responseData?.info || 'Failed to add notice board message. Status code error.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setBulkUpdateOfClientInformationError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setBulkUpdateOfClientInformationError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setBulkUpdateOfClientInformationError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setBulkUpdateOfClientInformationError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setBulkUpdateOfClientInformationError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to add notice board message. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setBulkUpdateOfClientInformationError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setBulkUpdateOfClientInformationError(`Failed to add notice board message. Please check your network connection and try again.`);
            }
        } finally {
            setBulkUpdateOfClientInformationLoading(false);
        }

        // onValueChange(teamData);
        // onClose();
    };

    const [clientTypeList, setClientTypeList] = useState([]);
    const [clientTypeError, setClientTypeError] = useState('');
    const [clientTypeLoading, setClientTypeLoading] = useState(false)
    const fetchClientTypesList = async () => {
        try {
            setClientTypeLoading(true);
            setClientTypeList([]);
            setClientTypeError('')
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_CLIENT_TYPE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const clientType = await responseData?.dataJ.map(service => ({
                                label: service.client_type_name,
                                value: service.client_type_id
                            }));
                            setClientTypeList(clientType)
                            //console.log('type list',clientTypeOptionsRef.current)
                        } else {
                            setClientTypeError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setClientTypeError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setClientTypeError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setClientTypeError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setClientTypeError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setClientTypeError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setClientTypeError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setClientTypeError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setClientTypeError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setClientTypeError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setClientTypeLoading(false);
        }
    }

    const [groupList, setGroupList] = useState([]);
    const [groupError, setGroupError] = useState('');
    const [groupLoading, setGroupLoading] = useState(false)
    const fetchGroupList = async () => {
        try {
            setGroupLoading(true);
            setGroupList([]);
            setGroupError('')
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_GROUP_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            // Transforming the data
                            const groups = await responseData?.dataJ.map(service => ({
                                label: service.group_name,
                                value: service.group_id
                            }));
                            setGroupList(groups)

                        } else {
                            setGroupError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setGroupError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setGroupError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setGroupError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setGroupError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setGroupError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setGroupError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setGroupError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setGroupError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setGroupError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setGroupLoading(false);
        }
    }

    const [stateList, setStateList] = useState([]);
    const [stateError, setStateError] = useState('');
    const [stateLoading, setStateLoading] = useState(false)
    const fetchStateList = async () => {
        try {
            setStateLoading(true);
            setStateError('');
            setStateList([])
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const payLoad = { "code_id": "states_list" }
            const response = await postData(ORG_GET_ALL_CODES_LIST, payLoad);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ) {
                            // Transforming the data
                            // Transforming the data
                            const state = await responseData?.dataJ.map(service => ({
                                label: service.state_name,
                                value: service.state_id
                            }));
                            setStateList(state)
                        } else {
                            setStateError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setStateError(responseData?.info || 'Failed to fetch inventory data. Please try again.');
                    }
                } else {
                    setStateError(responseData?.info || 'Failed to fetch Task Categorie data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setStateError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setStateError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setStateError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setStateError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setStateError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch Task Categorie data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setStateError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setStateError(`Failed to fetch Task Categorie data. Please check your network connection and try again.`);
            }
        } finally {
            setStateLoading(false);
        }
    }

    const [userList, setUserList] = useState([]);
    const [userLoading, setUserLoading] = useState(false);
    const [userError, setUserError] = useState('');
    const fetchUserList = async () => {
        try {
            setUserLoading(true);
            setUserError('');
            setUserList([]);

            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));

            // Make the API call
            const response = await getData(`${ORG_GET_EMPLOYEE_LIST}?emp_id_auth=${storedUserInfo?.emp_id}`);
            const responseData = await response.json();

            // Check for success (200) and internal status code
            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            //   setUserList(responseData?.dataJ);
                            const users = await responseData?.dataJ.map(user => ({
                                label: user.emp_name,
                                value: user.emp_id
                            }));
                            setUserList(users);
                        } else {
                            setUserError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setUserError(responseData?.info || 'Failed to fetch User data. Please try again.');
                    }
                } else {
                    setUserError(responseData?.info || 'Failed to fetch User data.');
                }
            }
            // Token-related errors: 400, 401, 403
            else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setUserError('Unauthorized access. Your session may have expired. Please log in again.');
                    // Optionally, redirect to the login page or refresh the token
                    // Example: redirectToLogin();
                } else {
                    setUserError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            }
            // Internal Server Error: 500
            else if (response?.status === 500) {
                setUserError(responseData?.info || 'Internal Server Error. Please try again later.');
            }
            // Unexpected or network-related errors
            else {
                setUserError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            // Handle various error scenarios
            if (error.response) {
                // Server responded with a status outside the 2xx range
                setUserError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
            } else if (error.request) {
                // Request was made but no response was received
                setUserError('No response received from the server. Please check your network connection and try again.');
            } else {
                // An error occurred in setting up the request
                setUserError(`Failed to fetch User data. Please check your network connection and try again.`);
            }
        } finally {
            setUserLoading(false);
        }
    }

    const [loacationLoading, setLoacationLoading] = useState(false);
    const [loacationError, setLoacationError] = useState('');
    const [loacationList, setLoacationList] = useState([]);
    const handleSelectLocation = (location) => {
        setSelectedLocation(location)
        setLocation(location?.location);
        setLoacationList([]);
    };
    const handleLocationSearch = async () => {
        try {
            setLoacationLoading(true);
            setLoacationError('');
            setLoacationList([]);
            setSelectedLocation(null);
            if (!location) {
                setLoacationError('Please enter valid text'); return;
            }
            const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
            const payLoad = { emp_id_auth: storedUserInfo?.emp_id, action: "search_list", search_word: location, search_type: "LOCATION" }
            const response = await postData(ORG_BULK_UPDATE_OF_CLIENTS_SEARCH, payLoad);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message.toLowerCase() === 'success') {
                        if (responseData?.dataJ?.length > 0) {
                            setLoacationList(responseData?.dataJ || []);
                        } else {
                            setLoacationError(responseData?.info || 'Data Not Found');
                        }
                    } else {
                        setLoacationError(responseData?.info || 'Failed to fetch User data. Please try again.');
                    }
                } else {
                    setLoacationError(responseData?.info || 'Failed to fetch User data.');
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                if (responseData?.message === 'Unauthorized' || responseData?.message === 'The incoming token has expired' || responseData?.message === 'Access Denied') {
                    setLoacationError('Unauthorized access. Your session may have expired. Please log in again.');
                } else {
                    setLoacationError(responseData?.info || 'Bad request. Please check the request parameters.');
                }
            } else if (response?.status === 500) {
                setLoacationError(responseData?.info || 'Internal Server Error. Please try again later.');
            } else {
                setLoacationError('Unexpected error occurred. Please try again later.');
            }
        } catch (error) {
            if (error.response) {
                setLoacationError(`Error: ${error.response.status}. ${error.response.data?.message || 'Failed to fetch User data. Please try again.'}`);
            } else if (error.request) {
                setLoacationError('No response received from the server. Please check your network connection and try again.');
            } else {
                setLoacationError(`Failed to fetch User data. Please check your network connection and try again.`);
            }
        } finally {
            setLoacationLoading(false);
        }
    }

    const dropdownRefs = useRef({}); // Ref for dropdown

    // Handle clicks outside dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            const isOutside = Object.keys(dropdownRefs.current).every(
                (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
            );
            if (isOutside) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{ width: '750px' }}>
                <button className="close-button" onClick={() => { handleClose(); }}>
                    <img src={closeIcon} alt="Close" style={styles.closeIcon} />
                </button>
                <h2 className="modal-title"> Bulk Update Client Information</h2>
                <hr className="footer-divider" />
                <div>
                    <h2 className="modal-title" style={{ fontSize: '12px' }}>Selected Client</h2>
                    <p style={{ color: '#5A55D2', textDecoration: 'underline' }}>{selectedClients?.length}</p>
                </div>
                <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                    <h2 className="modal-title" style={{ fontWeight: '600', fontSize: '19px' }}>Select information to update</h2>
                </div>
                <div className="form-grid">
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Group Name"] = el)}
                        isOpen={openDropdown === "Group Name"}
                        toggleDropdown={() => toggleDropdown("Group Name")}
                        label="Group Name"
                        options={groupList}
                        // value={fileUpload}
                        value={groupName}
                        onChange={(selectedOption) => setGroupName(selectedOption)}
                        loading={groupLoading}
                        errorMessage={groupError}
                    />
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Client Assigned User"] = el)}
                        isOpen={openDropdown === "Client Assigned User"}
                        toggleDropdown={() => toggleDropdown("Client Assigned User")}
                        label="Client Assigned User"
                        options={userList}
                        // value={fileUpload}
                        value={cleintAssignedUser}
                        onChange={(selectedOption) => setClientAssignedUser(selectedOption)}
                        loading={userLoading}
                        errorMessage={userError}
                    />
                    {/* <Dropdown
                        ref={(el) => (dropdownRefs.current["Primary Contact"] = el)}
                        isOpen={openDropdown === "Primary Contact"}
                        toggleDropdown={() => toggleDropdown("Primary Contact")}
                        label="Primary Contact"
                        options={fileUploadFrom}
                        // value={fileUpload}
                        value={fileUploadFrom.find((option) => option.value === fileUpload)}
                        onChange={(statusOptions) => setPrimaryContact(statusOptions.value)}
                    /> */}
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["Client Type"] = el)}
                        isOpen={openDropdown === "Client Type"}
                        toggleDropdown={() => toggleDropdown("Client Type")}
                        label="Client Type"
                        options={clientTypeList}
                        // value={fileUpload}
                        value={clientType}
                        onChange={(selectedOption) => setClientType(selectedOption)}
                        loading={clientTypeLoading}
                        errorMessage={clientTypeError}
                    />
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["NRI"] = el)}
                        isOpen={openDropdown === "NRI"}
                        toggleDropdown={() => toggleDropdown("NRI")}
                        label="NRI"
                        options={nriOptions}
                        // value={fileUpload}
                        value={nri}
                        onChange={(selectedOption) => setNri(selectedOption)}
                    />
                    <Input
                        label="Address"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="Enter address"
                        // errorMessage={addPhysicalTokenError}
                    // maxLength={10}
                    />
                    <div className="filter-field" style={{ paddingBottom: '10px' }}>
                        <label>City</label>
                        <TextInput
                            type="text"
                            placeholder="Enter city"
                            value={location}
                            onChange={(e) => {setLocation(e.target.value);setLoacationList([]);setSelectedLocation(null)}}
                            onRightClick={handleLocationSearch}
                            right={
                                loacationLoading ? (
                                    <Loader loading={loacationLoading} color={'var(--primary-color)'} size='small' /> // Show loader when loading
                                ) : (
                                    <img src={search} alt="Search" style={{ cursor: 'pointer', height: '20px', width: '20px' }} />
                                )
                            }
                            errorMessage={loacationError}
                        />
                        {loacationList?.length > 0 && (
                            <ul style={styles.dropdownList}>
                                {loacationList?.map((location, index) => (
                                    <li
                                        key={location}
                                        onClick={() => handleSelectLocation(location)}
                                        style={{
                                            ...styles.dropdownItem,
                                            borderBottom: index !== loacationList?.length - 1 ? '1px solid #ccc' : 'none', // Add line below except last item
                                        }}
                                    >
                                        {location?.location}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <Dropdown
                        ref={(el) => (dropdownRefs.current["State"] = el)}
                        isOpen={openDropdown === "State"}
                        toggleDropdown={() => toggleDropdown("State")}
                        label="State"
                        options={stateList}
                        // value={fileUpload}
                        value={state}
                        onChange={(selectedOption) => setState(selectedOption)}
                        loading={stateLoading}
                        errorMessage={stateError}
                    />
                    <Input
                        label="PIN Code"
                        value={pinCode}
                        onChange={(e) => setPinCode(e.target.value)}
                        placeholder="Enter PIN no."
                        errorMessage={addPhysicalTokenError}
                        maxLength={6}
                    />
                    {/* {!documentData && ( */}
                        <div style={{marginTop:'-4px'}}>
                            <label style={{ fontSize: '12px', color: '#343C44' }}>Upload Certificate</label>
                            <div style={styles.uploadContainer}>
                                <div style={styles.uploadBox} onClick={handleFileUploadClick}>
                                    <span style={styles.uploadText}><img src={uploadIcon} alt="Upload" style={styles.uploadIcon} />{uploadedFileName ? uploadedFileName : 'Upload (Valid file format Only)'}</span>
                                </div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={styles.fileInput}
                                    onChange={handleFileChange}
                                />
                            </div>
                            {documentUploadError && <div className="list-error-msg" style={{ display: 'flex', padding: '5px' }}><img
                                src={errorIcon}
                                alt="Error"
                                style={{ width: "12px", height: "12px", marginRight: '4px' }}
                            />{documentUploadError} </div>}
                        </div>
                    {/* )} */}
                    {/* <Input
                        label="Name of Client"
                        value={nameOfClient}
                        onChange={(e) => setNameOfClient(e.target.value)}
                        placeholder="Enter Client Name"
                        isEdit={!documentData}
                    /> */}
                    {/* <Input
                        label="Organisation Name"
                        value={organisationName}
                        onChange={(e) => setOrganisationName(e.target.value)}
                        placeholder="Enter Organisation Name"
                    />
                    <Input
                        label="PAN No"
                        value={panNo}
                        onChange={(e) => setPanNo(e.target.value)}
                        placeholder="Enter PAN No."
                        errorMessage={panError}
                        maxLength={10}
                    />
                    <Input
                        label="Email ID"
                        value={emailId}
                        onChange={(e) => setEmailId(e.target.value)}
                        placeholder="Enter Email ID"
                        errorMessage={emailError}
                    /> */}
                    {/* <Input
                        label="Phone No."
                        value={phoneNo}
                        onChange={(e) => setPhoneNo(e.target.value)}
                        placeholder="Enter Phone No."
                    /> */}
                    {/* <MobileInput
                        label="Phone No."
                        countryCode={countryCode}
                        mobileNumber={phoneNo}
                        onCountryChange={setCountryCode}
                        onMobileChange={setPhoneNo}
                        placeholder="Enter mobile number"
                        countries={[
                            { code: "IN", dialCode: "+91" },
                            { code: "US", dialCode: "+1" },
                            { code: "UK", dialCode: "+44" },
                        ]}
                        width="95%"
                    /> */}
                    {/* <Dropdown
                        ref={(el) => (dropdownRefs.current["status"] = el)}
                        isOpen={openDropdown === "status"}
                        toggleDropdown={() => toggleDropdown("status")}
                        label="Status"
                        options={statusOptions}
                        // value={statusOptions.find(option => option.value === status)?.label || "Select Status"}
                        value={statusOptions.find((option) => option.value === status)}
                        onChange={(selectedOption) => setStatus(selectedOption.value)}
                    /> */}
                    {/* <div>
                        <label style={{ fontSize: '12px', color: '#343C44' }}>Valid From</label>
                        <DateInput
                            label="Valid From"
                            value={validFrom}
                            onChange={(date)=>{
                                setValidFrom(date.target.value);
                                if(date.target.value){
                                    setValidFromError('')
                                }
                            }}
                            errorMessage={validFromError}
                        />
                    </div> */}
                    {/* <div>
                        <label style={{ fontSize: '12px', color: '#343C44' }}>Valid To</label>
                        <DateInput
                            label="Valid To"
                            value={validTo}
                            onChange={(date) => {
                                setValidTo(date.target.value);
                                if (date.target.value) {
                                  setValidToError('');
                                }
                              }}
                            errorMessage={validToError}
                            min={new Date().toISOString().split("T")[0]}
                        />
                    </div> */}
                    {/* <Input
                        label="Token Password"
                        value={tokenPassword}
                        onChange={(e) => setTokenPassword(e.target.value)}
                        placeholder="Enter Token Password"
                    /> */}
                </div>
                {/* <div style={styles.actionField}>
                    <label style={styles.label}>Remark</label>
                    <textarea placeholder="Add Remark" style={styles.textarea} value={addRemark} onChange={(e) => setAddRemark(e.target.value)}></textarea>
                    {addRemarkError && <div className="list-error-msg" style={{ display: 'flex', padding: '5px' }}><img
                        src={errorIcon}
                        alt="Error"
                        style={{ width: "12px", height: "12px", marginRight: '4px' }}
                    />{addRemarkError} </div>}
                </div> */}
                <hr className="footer-divider" />
                <div style={{ ...styles.buttonContainer, alignItems: 'center' }} >
                    <button className="add-client-button" onClick={ handleBulkUpdateOfClientInformation}
                        style={{
                            paddingLeft: '30px',
                            paddingRight: '30px',
                            gap: '10px',
                            opacity: bulkUpdateOfClientInformationLoading ? 0.5 : 1,
                            cursor: bulkUpdateOfClientInformationLoading ? 'not-allowed' : 'pointer',
                        }} disabled={bulkUpdateOfClientInformationLoading}>
                        {bulkUpdateOfClientInformationLoading && (
                            <Loader loading={bulkUpdateOfClientInformationLoading} color={'var(--background-color)'} size="small" />
                        )}
                        <span>{documentData ? 'Update' : 'Add'}</span>
                    </button>
                    <button className="cancel-button" onClick={() => { 
                        // handleClose();
                        handleOpenDeleteModal();
                    }}>
                        Cancel
                    </button>
                    {bulkUpdateOfClientInformationSuccess && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{bulkUpdateOfClientInformationSuccess} </div>}
                    {bulkUpdateOfClientInformationError && <div className="list-error-msg" style={{ marginBottom: '3px' }}>{bulkUpdateOfClientInformationError} </div>}
                </div>
            </div>
            <DeleteConfirmationModal
                    isOpen={isDeleteModalOpen}
                    message={`Are you sure you want to cancel`}
                    onClose={handleCloseDeleteModal}
                    onConfirm={() => {
                        handleClose();
                        handleCloseDeleteModal();
                    }}
                />
        </div>
    );
};

const styles = {
    closeIcon: {
        width: "16px",
        height: "16px",
    },
    formGrid: {
        display: "grid",
        gridTemplateColumns: "1fr 2fr 2fr",
        gap: "20px",
        marginTop: "20px",
    },
    buttonContainer: {
        display: "flex",
        justifyContent: "flex-start",
        gap: "10px",
        marginTop: "20px",
    },
    actionField: {
        display: "flex",
        flexDirection: "column",
        marginTop: '15px'
    },
    label: {
        fontSize: "12px",
        fontWeight: "500",
        marginBottom: "8px",
        color: "#343C44",
    },
    textarea: {
        padding: "10px",
        border: "1px solid #D6E4EC",
        borderRadius: "5px",
        resize: "none",
        height: "60px",
        fontSize: "14px",
        color: "#333",
        fontFamily: 'Roboto',
        width: '480px'
    },
    uploadContainer: {
        marginTop: "5px",
    },
    uploadBox: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #858585",
        borderRadius: "50px",
        padding: "7px",
        cursor: "pointer",
        justifyContent: 'space-between'
    },
    uploadIcon: {
        width: "20px",
        height: "20px",
        marginRight: "10px",
    },
    uploadText: {
        display: 'flex',
        color: "#40513B ",
        fontSize: "12px",
        fontWeight: 500,
        gap: "1px",
        alignItems: 'center',
    },
    fileInput: {
        display: "none",
    },

    dropdownList: {
        position: 'absolute',
        top: '90%',
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderRadius: '4px',
        maxHeight: '200px',
        overflowY: 'auto',
        zIndex: 1000,
        padding: 0, // Remove default padding
        margin: 0, // Remove default margin
        listStyleType: 'none', // Remove the dots
    },

    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee', // Default for all items
        backgroundColor: '#fff',
        hover: {
            backgroundColor: '#f0f0f0',
        },
    },
};

export default BulkUpdateClientInformationModal;
